// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13 4.06189V1H11V4.06189C7.38128 4.51314 4.51314 7.38128 4.06189 11H1V13H4.06189C4.51314 16.6187 7.38128 19.4869 11 19.9381V23H13V19.9381C16.6187 19.4869 19.4869 16.6187 19.9381 13H23V11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-focus-filled')
export default class FocusFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'focus-filled',
    }
  }
}
